import type { AnyModel } from "mobx-keystone";
import { createContext } from "mobx-keystone";
import type RootStore from "../root";
import type { GlobalStore } from "../stores/global";

type GlobalKeys<T extends AnyModel> = {
  [K in keyof T["$"]]: T["$"][K] extends GlobalStore
    ? K
    : T["$"][K] extends infer R
      ? Exclude<R, null | undefined> extends AnyModel
        ? `${Exclude<K, symbol>}.${Exclude<GlobalKeys<Exclude<R, null | undefined>>, symbol>}`
        : never
      : never;
}[keyof T["$"]];
type RootStoreGlobal = GlobalKeys<RootStore>;

declare global {
  var keystone_ContextRegister: Record<
    string,
    ReturnType<typeof createContext>
  >;
}

const keystoneContextRegister: Record<
  string,
  ReturnType<typeof createContext>
> = globalThis.keystone_ContextRegister ?? {};
globalThis.keystone_ContextRegister = keystoneContextRegister;

export function registerContext<T>(name: RootStoreGlobal) {
  const ctx = createContext<T>();
  globalThis.keystone_ContextRegister[name] = ctx;
  return ctx;
}
